import React, { useContext } from 'react';
import cn from 'classnames';
import HeaderContext from './HeaderContext';

const Overlay = () => {
  const { activeFlyout, activeMegaMenu, isSuggestionsActive } =
    useContext(HeaderContext);
  const isOverlayVisible =
    activeFlyout || activeMegaMenu || isSuggestionsActive;
  const overlayClassName = cn('c-header__overlay', {
    'is-visible': isOverlayVisible,
  });

  return <div className={overlayClassName} />
};

export default Overlay;
